<template>
<div>
  <div class="odmik-tabs">
    <p class="navadno-besedilo">
      Mejo porabe lahko določite na posamezni stacionarni ali mobilni telefonski številki, lahko pa jo določite
      tudi celemu priključku (vsem številkam). Ko boste dosegli izbrani znesek porabe, vas bomo o tem obvestili z SMS
      sporočilom. Ob vklopu storitve boste prejeli obvestilo, še vedno pa boste lahko nemoteno uporabljali vse storitve.
      Morebitne blokade klicev ali prenos podatkov lahko nastavljate v meniju
      <a class="primarna-barva" href="/Nastavitve/NastavitveTelefonija">Nastavitve / Telefonija</a>.
    </p>
  </div>
  <div v-if="seznamTelefonskihStevilkUmts.length > 0">
    <el-form label-width="200px" :label-position="formaOrientacija" class="custom-forma nova-vrstica-forma custom-labels">
      <el-form-item label="Telefonska številka">
        <el-select
          value-key="telStevilka"
          v-model="nastavitevMejePorabe"
          placeholder="Izberite tel. številko"
          class="odmik velikost-selecta"
          :disabled="seznamTelefonskihStevilkUmts.length === 0"
          filterable>
          <el-option-group
            v-for="grupa in seznamTelefonskihGrupirano"
            :key="grupa.label"
            :label="grupa.label">
            <el-option
              v-for="(data, key) in grupa.seznamTelStevilk"
              :value="(typeof data.msisdn !== 'undefined') ? data.msisdn : data.telefonska_stevilka"
              :key="key"
              :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="Višina meje (brez ddv)">
        <el-input v-model="threshold" type="number" class="velikost-inputa">
          <template slot="append">€</template>
        </el-input>
      </el-form-item>
      <el-form-item label="Vklop obveščanja">
        <el-date-picker
          v-model="datumOd"
          type="date"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          placeholder="Izberite začetek"
          class="velikost-inputa">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Izklop obveščanja">
        <el-date-picker
          v-model="datumDo"
          type="date"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          placeholder="Izberite konec"
          class="velikost-inputa">
        </el-date-picker>
      </el-form-item>
      <el-form-item class="label-height" label="Obvestilo na">
        <div v-if="nastavitevMejePorabe !==''" style="line-height: 18px;" class="checkbox-label">
          <el-checkbox class="velikost-input" v-model="obvestiloNarocniku">
            kontaktno številko naročnika {{telefonskaStevilkaStranke}}
          </el-checkbox>
        </div>
        <div v-if="nastavitevMejePorabe !== ''" style="line-height: 18px;" class="checkbox-label">
          <el-checkbox class="velikost-input" v-model="obvestiloUporabniku">
            kontaktno številko uporabnika {{ nastavitevMejePorabe }}
          </el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <div class="odmik-top">
      <el-button class="gumb-potrdi velikost-gumba-meja-porabe" @click="NastaviUmtsMejoPorabe">
        DODAJ MEJO
      </el-button>
    </div>
  </div>
  <div style="padding-top: 30px" v-if="seznamTelefonskihStevilkUmts.length > 0">
    <div>
      <hr class="hr-stil">
    </div>
    <div style="padding-top: 30px">
      <div>
        <p class="open-sans-24pt">
          Vklopljene meje porabe
        </p>
      </div>
      <div class="odmik-naslov">
        Izberi telefonsko številko za katero želite preveriti mejo porabe
          <el-select v-model="pregledVklopljeneMejePorabe"
                     filterable
                     placeholder="Telefonska številka"
                     class="velikost-inputa-telefonska"
                     @change="GetUmtsMejoPorabe">
            <el-option v-for="(data, idx) in telefonskeStevilke"
                       :value="data.telefonska_stevilka"
                       :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)"
                       :key="idx">
            </el-option>
          </el-select>
      </div>
      <div v-if="seznamPodatkovVklopljeneMejePorabe.length > 0" style="padding-top: 30px">
        <div v-show="prikazTabele === '1'">
          <el-table :data="seznamPodatkovVklopljeneMejePorabe" v-loading="nalaganjeMejePorabe" width="100%">
            <el-table-column prop="number"
                             label="številka kupca">
            </el-table-column>
            <el-table-column label="Meja (brez DDV)">
              <template slot-scope="scope">
                  <span>
                    {{ scope.row.threshold + ' €' }}
                  </span>
              </template>
            </el-table-column>
            <el-table-column prop="startDate"
                             label="Datum od">
            </el-table-column>
            <el-table-column prop="endDate"
                             label="Datum do">
            </el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <span v-if="today < scope.row.convertDate">
                  <a @click="BrisanjeMejePorabe(scope.row.nlid, scope.row.number)"
                     style="cursor: pointer">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                  </a>
                </span>
                <span v-else>
                  UMTS meja je že zaključena.
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="prikazTabele === '0'">
          <el-table
            :data="seznamPodatkovVklopljeneMejePorabe"
            :expand-row-keys="expandRowKeys"
            :row-key="row => row.number + row.threshold + row.startDate"
            @expand-change="IzbiraVrsticeZaPrikazPodatkov">
            <el-table-column
              prop="number"
              label="številka kupca">
            </el-table-column>
            <el-table-column
              label="Meja (brez DDV)">
              <template slot-scope="scope">
                  <span>
                    {{ scope.row.threshold + ' €' }}
                  </span>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <div class="postavitev-input">
                    <el-form label-width="150px" :label-position="formaOrientacija">
                      <el-form-item label="številka kupca:">
                        <b>{{scope.row.number}}</b>
                      </el-form-item>
                      <el-form-item label="Meja (brez DDV):">
                        <b>{{scope.row.threshold}} EUR</b>
                      </el-form-item>
                      <el-form-item label="Datum od:">
                        <b>{{scope.row.startDate}}</b>
                      </el-form-item>
                      <el-form-item label="Datum do:">
                        <b>{{scope.row.endDate}}</b>
                      </el-form-item>
                    </el-form>
                    <div style="padding-top: 5px">
                      <span v-if="today < scope.row.convertDate">
                        <a @click="BrisanjeMejePorabe(scope.row.nlid, scope.row.number)"
                           style="cursor: pointer">
                          <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                          <b style="color: #111820;">
                            ODSTRANI MEJO
                          </b>
                        </a>
                      </span>
                      <span v-else>
                        <b>
                          UMTS meja je že zaključena.
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding-top: 30px">
          <div class="text-center" style="cursor: pointer;">
            <el-pagination
              :hide-on-single-page="true"
              @current-change="PrikaziStran"
              :page-size="4"
              layout="prev, pager, next"
              :total="dolzinaSeznamaMejaporabe"
              small>
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-else class="obvestilo-prazen-seznam" style="text-align: left">
        Meja porabe trenutno ni aktivirana na nobeni telefonski številki.
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  Table, TableColumn, Input, Button, Form, Select, Option, OptionGroup,
  Collapse, CollapseItem, DatePicker, Checkbox, MessageBox
} from 'element-ui'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import Vue from 'vue'
export default {
  name: 'MejaPorabe',
  mixins: [SirinaOkna, PrikazVsebine, FormatirajTelefonskoStevilko],
  components: {
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [DatePicker.name]: DatePicker,
    [Checkbox.name]: Checkbox,
    [CollapseItem.name]: CollapseItem,
    [OptionGroup.name]: OptionGroup
  },
  data () {
    return {
      nalaganjeMejePorabe: false,
      pridobljeneUmtsMejePorabe: [],
      threshold: null,
      datumOd: null,
      datumDo: null,
      obvestiloNarocniku: false,
      obvestiloUporabniku: false,
      mejnaSirina: 350,
      formaOrientacija: 'left',
      telefonskaStevilka: '',
      telefonskaStevilkaPregled: '',
      pregledVklopljeneMejePorabe: '',
      nastavitevMejePorabe: '',
      telefonskeStevilke: [],
      seznamPodatkovVklopljeneMejePorabe: [],
      dolzinaSeznamaMejaporabe: null,
      prikazTabele: '1',
      mejnaSirinaTabela: 1340,
      expandRowKeys: [],
      today: new Date()
    }
  },
  props: {
    idPrikljucek: '',
    seznamTelefonskihStevilkUmts: Array,
    seznamTelefonskihGrupirano: Array,
    telefonskaStevilkaStranke: ''
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.PridobivanjePodatkov()
  },
  methods: {
    IzbiraVrsticeZaPrikazPodatkov (row) {
      const id = row.number + row.threshold + row.startDate
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    PridobivanjePodatkov () {
      this.pregledVklopljeneMejePorabe = ''
      this.nastavitevMejePorabe = ''
      this.telefonskeStevilke = []
      this.prikljucekNastavitevMejePorabe = ''
      this.prikljucekpregledVklopljeneMejePorabe = ''
      this.telefonskeStevilke = this.seznamTelefonskihStevilkUmts
      for (let i = 0; i < this.telefonskeStevilke.length; i++) {
        this.nastavitevMejePorabe = this.telefonskeStevilke[0].telefonska_stevilka
        if (this.nastavitevMejePorabe === this.telefonskeStevilke[i].telefonska_stevilka) {
          this.prikljucekNastavitevMejePorabe = ''
          this.prikljucekNastavitevMejePorabe = this.telefonskeStevilke[i].id_prikljucek
        }
        this.pregledVklopljeneMejePorabe = ''
        this.pregledVklopljeneMejePorabe = this.telefonskeStevilke[0].telefonska_stevilka
        if (this.pregledVklopljeneMejePorabe === this.telefonskeStevilke[i].telefonska_stevilka) {
          this.prikljucekpregledVklopljeneMejePorabe = ''
          this.prikljucekpregledVklopljeneMejePorabe = this.telefonskeStevilke[0].id_prikljucek
        }
      }
      this.GetUmtsMejoPorabe()
    },
    GetUmtsMejoPorabe () {
      this.nalaganjeMejePorabe = true
      if (this.prikljucekpregledVklopljeneMejePorabe !== '') {
        let param = ['idPrikljucek=' + this.prikljucekpregledVklopljeneMejePorabe]
        param.push('stevilka=' + this.pregledVklopljeneMejePorabe)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiUmtsMejoPorabe?',
          param,
          null,
          'SetUmtsMejoPorabe',
          'ErrUmtsMejoPorabe')
      }
    },
    SetUmtsMejoPorabe (podatki) {
      this.pridobljeneUmtsMejePorabe = []
      this.pridobljeneUmtsMejePorabe = podatki.data.reverse()
      for (let i = 0; i < this.pridobljeneUmtsMejePorabe.length; i++) {
        let pridobjenDatumDo = this.pridobljeneUmtsMejePorabe[i].endDate
        let dan = pridobjenDatumDo.substring(0, 2)
        let mesec = pridobjenDatumDo.substring(3, 5)
        let leto = pridobjenDatumDo.substring(6, 10)
        let formatDatumaDo = leto + '-' + mesec + '-' + dan
        let date = new Date(formatDatumaDo)
        Vue.set(this.pridobljeneUmtsMejePorabe[i], 'convertDate', date)
      }
      if (typeof this.pridobljeneUmtsMejePorabe !== 'undefined') {
        let tmpArray = []
        this.dolzinaSeznamaMejaporabe = this.pridobljeneUmtsMejePorabe.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaSeznamaMejaporabe; i += chunk) {
          tmpArray.push(this.pridobljeneUmtsMejePorabe.slice(i, i + chunk))
        }
        this.pridobljeneUmtsMejePorabe = tmpArray
        this.PrikaziStran(1)
      }
    },
    PrikaziStran (stran) {
      if (typeof this.pridobljeneUmtsMejePorabe[stran - 1] !== 'undefined') {
        this.seznamPodatkovVklopljeneMejePorabe = this.pridobljeneUmtsMejePorabe[stran - 1]
      } else {
        this.seznamPodatkovVklopljeneMejePorabe = []
      }
      this.nalaganjeMejePorabe = false
    },
    ErrUmtsMejoPorabe (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeMejePorabe = false
    },
    NastaviUmtsMejoPorabe () {
      if (this.prikljucekNastavitevMejePorabe !== null) {
        if (!this.ValidirajNastavitveMejePorabe()) {
          return false
        }
        let param = ['idPrikljucek=' + this.prikljucekNastavitevMejePorabe]
        param.push('stevilka=' + this.nastavitevMejePorabe)
        param.push('threshold=' + this.threshold)
        param.push('datumOd=' + this.datumOd)
        this.datumDo = (this.datumDo !== null) ? this.datumDo : ''
        param.push('datumDo=' + this.datumDo)
        param.push('obvestiloNarocniku=' + this.obvestiloNarocniku)
        param.push('obvestiloUporabniku=' + this.obvestiloUporabniku)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/nastaviUmtsMejoPorabe?',
          param,
          null,
          'SeUmtsMejoPorabe',
          'ErUmtsMejoPorabe')
      }
    },
    ValidirajNastavitveMejePorabe () {
      if (this.threshold === null) {
        this.ErrUmtsMejoPorabe({ message: 'Izberite mejo porabe.' })
        return false
      }
      if (this.datumOd === null) {
        this.ErrUmtsMejoPorabe({ message: 'Izberite datum začetka omejitve.' })
        return false
      }

      return true
    },
    SeUmtsMejoPorabe () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno nastavljena meja porabe.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUmtsMejoPorabe()
    },
    ErUmtsMejoPorabe (podatki) {
      this.ShowWarningMessage(podatki)
    },
    BrisanjeMejePorabe (nlid, number) {
      MessageBox.confirm('Ali ste prepričani, da želite zaključiti mejo porabe?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        let param = ['idPrikljucek=' + this.prikljucekNastavitevMejePorabe]
        param.push('stevilka=' + number)
        param.push('nlid=' + nlid)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/umts/zakljucUmtsMejoPorabe',
          param,
          null,
          'SetIzbrisanaMeja',
          'ErUmtsMejoPorabe')
      }).catch((err) => {
        err = null
      })
    },
    SetIzbrisanaMeja () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Meja porabe uspešno izbrisana.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUmtsMejoPorabe()
    }
  },
  watch: {
    seznamTelefonskihStevilkUmts: function () {
      if (this.seznamTelefonskihStevilkUmts !== null) {
        this.pregledVklopljeneMejePorabe = ''
        this.nastavitevMejePorabe = ''
        this.telefonskeStevilke = []
        this.prikljucekNastavitevMejePorabe = ''
        this.prikljucekpregledVklopljeneMejePorabe = ''
        this.PridobivanjePodatkov()
      }
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/MejaPorabe.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/MejaPorabe.vue